import React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Media} from 'reactstrap';
import { Translate } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faPrint, faChartPie, faChartBar, faUser, faCogs } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";


export default class NavbarMobile extends React.Component {
    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    render() {
        return (

            <div>

                <Navbar className="navbar-mobile" color="faded" dark>
                    <NavbarBrand href="/" className="mr-auto">
                        <Media src={require('../../img/logo-gs-a.png')} alt="Company logo"
                               className="logo-mob"/>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2 navbar-button" />
                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Nav navbar>
                            <NavItem>
                                <NavLink to="/dashboard" className="navbar-button">
                                    <FontAwesomeIcon icon={faHome} />{' '}
                                    <Translate id="navbar.home" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/report-results" className="navbar-button">
                                    <FontAwesomeIcon icon={faPrint} />{' '}
                                    <Translate id="navbar.print-results" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/report-average" className="navbar-button">
                                    <FontAwesomeIcon icon={faChartPie} />{' '}
                                    <Translate id="navbar.student-average" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/report-lesson-average" className="navbar-button">
                                    <FontAwesomeIcon icon={faChartBar} />{' '}
                                    <Translate id="navbar.student-lesson-average" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/profile-register" className="navbar-button">
                                    <FontAwesomeIcon icon={faUser} />{' '}
                                    <Translate id="navbar.manage-students" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink to="/update-information" className="navbar-button">
                                    <FontAwesomeIcon icon={faCogs} />{' '}
                                    <Translate id="navbar.settings" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/navbar/navbar-mobile.js